import React from 'react';
import {
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  subDays,
  subWeeks,
  subMonths,
} from 'date-fns';

export const buildPresets = () => {
  const today = new Date();
  return [
    { label: 'Today', from: startOfDay(today), to: endOfDay(today) },
    { label: 'Yesterday', from: startOfDay(subDays(today, 1)), to: endOfDay(subDays(today, 1)) },
    { label: 'This Week', from: startOfWeek(today), to: endOfWeek(today) },
    { label: 'Last 7 Days', from: startOfDay(subDays(today, 6)), to: endOfDay(today) },
    { label: 'Last 30 Days', from: startOfDay(subDays(today, 29)), to: endOfDay(today) },
    { label: 'This Month', from: startOfMonth(today), to: endOfMonth(today) },
    {
      label: 'Last Week',
      from: startOfWeek(subWeeks(today, 1)),
      to: endOfWeek(subWeeks(today, 1)),
    },
    {
      label: 'Last Month',
      from: startOfMonth(subMonths(today, 1)),
      to: endOfMonth(subMonths(today, 1)),
    },
  ];
};

export const Checkmark = ({ size = 9 }) => (
  <svg width={size} height={size} viewBox="0 0 10 10" fill="none">
    <polyline
      points="1.5,5 4,7.5 8.5,2"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MF_BLANK = -1;
export const MF_NOT_BLANK = -2;
export const UNUSED_FIELD_NAME = 'RMSSelectFilterPlaceholderField';
export const IS_BLANK = 'Is Blank';
export const IS_NOT_BLANK = 'Is Not Blank';

export const DEBOUNCE_MS = 350;
export const SCROLL_OFFSET = 75;
export const PAGE_SIZE = 50;
